import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./ListItem.module.css";

//#region [Props]
type ListItemProps = {
    children: ReactNode;
    className?: string;
};
//#endregion

//#region [Component]
export default function ListItem({ children, className }: ListItemProps) {
    return <li className={classNames(styles.ListItem, className)}>{children}</li>;
}
//#endregion

//#region [Styles]

//#endregion